<p-dialog
  [closable]="showCloseButton()"
  [draggable]="draggable()"
  [header]="title()"
  [modal]="true"
  [resizable]="draggable()"
  [style]="dialogStyle()"
  [styleClass]="className()"
  [visible]="!hideDialog()"
  (onHide)="closeModalEmit()"
>
  <ng-content />
</p-dialog>
